import React, { useState, useEffect, useCallback } from 'react';
import { GitCommitHorizontal, ChevronRight, X } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Compteur simple des divergences Statut × Facturation (SPOT uniquement).
 * Phase 1 "Observe & Learn" — affichage non-intrusif pour piloter la cohérence.
 *
 * Types trackés :
 * - ahead_financial : facturation avance plus vite que opérationnel
 * - ahead_operational : opérationnel avance plus vite que financial
 * - inconsistent : contradictoire (ex: annulé + payé)
 */
const WorkflowDivergenceCounter = ({ onClick }) => {
  const [counts, setCounts] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const [loading, setLoading] = useState(true);
  const fetchCounts = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/admin/dashboard/workflow-divergences`, {});
      setCounts(res.data?.counts || null);
    } catch (err) {
      // Silently ignore - banner won't show
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchCounts(); }, [fetchCounts]);

  if (loading || dismissed || !counts || counts.total === 0) return null;

  return (
    <div
      className="flex items-center justify-between h-10 px-4 bg-blue-50 border border-blue-200 mb-3 rounded-sm"
      data-testid="workflow-divergence-banner"
    >
      <div className="flex items-center gap-2.5">
        <GitCommitHorizontal className="w-4 h-4 text-blue-600 flex-shrink-0" />
        <span className="text-sm font-medium text-blue-900">
          {counts.total} divergence{counts.total > 1 ? 's' : ''} Statut × Facturation
        </span>
        <span className="hidden md:inline-flex items-center gap-2 text-xs text-blue-700">
          {counts.ahead_financial > 0 && (
            <span className="bg-blue-100 px-1.5 py-0.5 rounded">
              {counts.ahead_financial} facturation avancée
            </span>
          )}
          {counts.ahead_operational > 0 && (
            <span className="bg-blue-100 px-1.5 py-0.5 rounded">
              {counts.ahead_operational} livraison avancée
            </span>
          )}
          {counts.inconsistent > 0 && (
            <span className="bg-red-100 text-red-800 px-1.5 py-0.5 rounded">
              {counts.inconsistent} contradictoire{counts.inconsistent > 1 ? 's' : ''}
            </span>
          )}
        </span>
      </div>
      <div className="flex items-center gap-3">
        {onClick && (
          <button
            onClick={onClick}
            className="flex items-center gap-1 text-xs font-semibold text-blue-800 hover:text-blue-950"
            data-testid="view-divergences-btn"
          >
            Analyser <ChevronRight className="w-3 h-3" />
          </button>
        )}
        <button
          onClick={() => setDismissed(true)}
          className="text-blue-400 hover:text-blue-600"
          aria-label="Masquer"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default WorkflowDivergenceCounter;
